module.exports = __webpack_public_path__ + "assets/img/neoprene-shoe-low.f35fe4a0.png";